import styled from 'styled-components'

import theme from '../../theme'

const RadioContainer = styled.span`
  label {
    cursor: pointer;
  }
  label.disabled {
    cursor: not-allowed;
  }
  label input.checkbox {
    cursor: pointer;
    width: 16px;
    height: 16px;
    border: 1px solid ${theme.colors.gray5};
    margin: 0px;
  }
  label input.radio {
    position: absolute;
    top: 0;
    left: 0;
    visibility: hidden;
    pointer-events: none;
  }
  label input:disabled span {
    background: ${theme.colors.gray4};
  }
  label span.unchecked {
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    padding: 16px;
    gap: 8px;
    background: ${theme.colors.white};
    border: 1px solid transparent;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
    border-radius: 4px;
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 1;
  }
  label span.checked {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    padding: 16px;
    gap: 8px;
    background: ${theme.colors.brandPrimary1};
    border: 1px solid ${theme.colors.brandPrimary3};
    color: ${theme.colors.brandPrimary7};
    font-weight: ${theme.fontWeights.semiBold};
    border-radius: 4px;
    flex: none;
    order: 1;
    align-self: stretch;
    flex-grow: 1;
  }
`

export { RadioContainer }
